import { BellOff, CheckCheck, ShieldCheck } from 'lucide-react';

/**
 * Empty-state placeholder for notification lists.
 *
 * Props:
 *   variant:  'default' | 'unread' | 'action'
 *   compact:  boolean — tighter padding for the dropdown
 *
 * The three variants map to:
 *   default → BellOff   "No notifications yet"
 *   unread  → CheckCheck "You're all caught up"
 *   action  → ShieldCheck "Nothing needs attention"
 */
export function NotificationEmptyState({ variant = 'default', compact = false }) {
  const cfg = VARIANTS[variant] ?? VARIANTS.default;
  const Icon = cfg.icon;
  const padding = compact ? 'px-6 py-14' : 'px-4 py-16';

  return (
    <div className={`flex flex-col items-center justify-center text-center ${padding}`}>
      <span className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
        <Icon className="h-7 w-7 text-slate-400 dark:text-slate-500" strokeWidth={1.5} />
      </span>
      <p className="font-serif text-base font-semibold text-slate-900 dark:text-white">{cfg.title}</p>
      <p className="mt-1 max-w-[15rem] text-sm text-slate-500 dark:text-slate-400">{cfg.subtitle}</p>
    </div>
  );
}

const VARIANTS = {
  default: {
    icon: BellOff,
    title: 'No notifications yet',
    subtitle: 'You will see updates here as they arrive.',
  },
  unread: {
    icon: CheckCheck,
    title: "You're all caught up",
    subtitle: 'No unread notifications.',
  },
  action: {
    icon: ShieldCheck,
    title: 'Nothing needs attention',
    subtitle: 'No action-required notifications.',
  },
};
